import React, { memo, forwardRef, MutableRefObject } from "react";
import { Link } from "react-router-dom";
import { messageRelativePastTime } from "../../../actions/messageRelativePastTime";
import Avatar from "../../avatar";
import ReadInfo from "../readInfo";
import { openPlayerPopup } from "../../../actions";
import { MessageProps } from "../types";
import { Championship } from "../../../types";
import { ChampionshipItem } from "../../championshipBar";

const ChampionshipMessage = memo(
	forwardRef(
		(
			{ message, partners, partner, lastReadByPartners, userId }: MessageProps,
			ref: MutableRefObject<HTMLDivElement>
		) => {
			const relativePastTimeString = messageRelativePastTime(message?.createdAt);
			const championship: Championship = message?.text.payload.championshipPayload;
			return (
				<div
					className={`item message${message?.text.deleted! ? " deleted" : ""}`}
					ref={ref}
					data-id={message?.messageId}
				>
					<div className="itemImage" onClick={openPlayerPopup.bind(null, partner?.userId)}>
						<Avatar photoUrl={partner?.photoUrl} />
					</div>
					<div className="itemBody">
						<div className="messageBody" title={relativePastTimeString}>
							<div className="text">{message?.text.payload.messagePayload.message}</div>
							{championship && (
								<Link to={`/championship/${championship.uuid}`}>
									<ChampionshipItem championship={championship} className="inMessage" />
								</Link>
							)}
						</div>
						{lastReadByPartners ? (
							<ReadInfo
								partners={partners}
								lastReadByPartners={lastReadByPartners}
								userId={userId}
								senderId={message?.senderId}
							/>
						) : null}
					</div>
				</div>
			);
		}
	)
);

ChampionshipMessage.displayName = "ChampionshipMessage";
export default ChampionshipMessage;
